export default __webpack_public_path__ + "static/media/headset.2f5478ce.jfif";